import BaseUISystem from './BaseUISystem';
import {PopupID} from '../../State/UI/PopupID';
import BasePopupHandler from 'System/UI/Menu/BasePopupHandler';
import GameObject from 'GameObject/GameObject';
import UIItem, {ITextData} from 'Prototype/UI/UIItem';
import {IUIButtonData} from 'Prototype/UI/BaseElements/UIButton';

export default class ErrorPopupHandler extends BasePopupHandler {
    private submitHandler: Function;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.ERROR_POPUP, uiSystem);
    }

    public createPopup(params?: any) {
        this.submitBtnParams.text.style = this.getSubmitStyle();
        super.createPopup({
            buttons: [this.submitBtnParams, this.closeBtnParams],
        });
    }

    public onShow(params?: any): void {
        this.title = params.title;

        this.errorText.text.text = params.body;
        const errorTxt: GameObject<PIXI.Container> = UIItem.createText(this.errorText.text);
        this.background.addChild(errorTxt);

        if (params?.disallowClose) {
            this.background.removeChild(this.background.findChildByName('popup_close_button'));
        }

        if (params?.submitAction) {
            this.submitHandler = params.submitAction;
        }
    }

    protected onSubmit(): void {
        if (!this.submitHandler) {
            super.onSubmit();
        } else {
            this.submitHandler();
        }
    };

    private getSubmitStyle() {
        return {
            fontFamily: 'FrancoisOne',
            strokeThickness: 5,
            fill: 'white',
            fontSize: '50px',
            stroke: '#187630',
            lineJoin: 'miter',
            miterLimit: 2,
            align: 'center',
        };
    }

    protected errorText: {
        text: ITextData;
    } = {
        text: {
            name: 'errorText',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
            bounds: [700, 200],
            style: {
                font: 'FrancoisOne',
                fill: '#bb3c2f',
                fontSize: '35px',
            },
        },
    };

    protected titleParams: ITextData = {
        name: 'popup_title',
        text: 'Title',
        style: {
            fontFamily: 'FrancoisOne',
            strokeThickness: 5,
            fill: 'white',
            fontSize: '45px',
            stroke: '#ab3143',
            lineJoin: 'miter',
            miterLimit: 2,
            align: 'center',
        },
        layout: {
            anchors: [0.5, 0.45, 0.5, 0.45],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        bounds: [460, 240],
    };
}
